import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "roaming" }
const _hoisted_2 = { class: "roaming-wrapper" }
const _hoisted_3 = { class: "roaming-header" }
const _hoisted_4 = { class: "h3" }
const _hoisted_5 = { class: "roaming-main" }
const _hoisted_6 = { class: "roaming-main__wrapper" }
const _hoisted_7 = { class: "roaming-main__header" }
const _hoisted_8 = { class: "roaming-main__header-title" }
const _hoisted_9 = { class: "h1" }
const _hoisted_10 = { class: "roaming-banner" }
const _hoisted_11 = { class: "roaming-banner__wrapper" }
const _hoisted_12 = { class: "roaming-banner__content" }
const _hoisted_13 = { class: "roaming-banner__countries" }
const _hoisted_14 = { class: "footnote color-text-primary uppercase" }
const _hoisted_15 = { class: "roaming-info__row" }

import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import RoamingSearch from "@/components/roaming/RoamingSearch.vue";
import RoamingInfoDetails from "@/components/roaming/RoamingInfoDetails.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import { useI18n } from "vue-i18n";
import { useRoamingView } from "@/composables/roaming/useRoamingView";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoamingView',
  setup(__props) {

const { t } = useI18n();
const roamingInfoTitle = ref<HTMLElement | null>(null);

const {
  identicalCountriesWithActive,
  isSticky,
  othersCountriesList,
  othersCountriesCount,
  popularCountries,
  selectedCountry,
  selectedZone,
  selectCountry,
} = useRoamingView(roamingInfoTitle);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "account",
          class: "roaming-header__back"
        }, {
          default: _withCtx(() => [
            _createVNode(BaseFigureForIcon, {
              size: "medium",
              color: "white",
              icon: "arrow",
              position: "left",
              "is-button": ""
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass(["roaming-header__title", _unref(isSticky) ? 'visible' : ''])
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("roaming.page.title")), 1)
        ], 2)
      ]),
      _createElementVNode("main", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("roaming.page.selectCountry")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(RoamingSearch, {
                    class: "roaming-banner__countries-search",
                    modelValue: _unref(selectedCountry),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedCountry) ? (selectedCountry).value = $event : null))
                  }, null, 8, ["modelValue"]),
                  (_unref(popularCountries))
                    ? (_openBlock(), _createBlock(_unref(Swiper), {
                        key: 0,
                        "space-between": 8,
                        "slides-per-view": 'auto',
                        class: "roaming-banner__countries-popular"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(popularCountries), (item, index) => {
                            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                              key: index,
                              onClick: ($event: any) => (_unref(selectCountry)(item)),
                              class: _normalizeClass(["roaming-banner__countries-popular__item", {
                        '--active': _unref(identicalCountriesWithActive)(item.uuid),
                      }])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(item.country_name_ru), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "class"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (_unref(selectedCountry))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "roaming-info",
                ref_key: "roamingInfoTitle",
                ref: roamingInfoTitle
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(RoamingInfoDetails, {
                    country: _unref(selectedCountry),
                    zone: _unref(selectedZone),
                    othersCountriesList: _unref(othersCountriesList),
                    othersCountriesCount: _unref(othersCountriesCount),
                    onSelect: _unref(selectCountry)
                  }, null, 8, ["country", "zone", "othersCountriesList", "othersCountriesCount", "onSelect"])
                ])
              ], 512))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})